import amplitude from 'amplitude-js';

const amplitudClient = amplitude.getInstance()
amplitudClient.init("5f5a0f32055a2213b344bf0d1e70a01d");

amplitudClient.setDomain('gaussonline.com')

export function setAnalyticsUserId(userid) {
    amplitudClient.setUserId(userid)
}

if(window.__USER_EMAIL) {
    setAnalyticsUserId(window.__USER_EMAIL)
}

export function trackGaussEvent(name, payload) {
    if(process.env.NODE_ENV === 'development') {
        console.log('TRACKIGN EVENT DEV', name, payload)
        return
    }


    try {
        gtag('event', name, payload)
        if(fbq) fbq('trackCustom', name)
     } catch (e ) {
        console.log('some error at sending event', e)
    }



    amplitudClient.logEvent(`TOOL_${name}`, payload)
}

